<script>
import { FontAwesomeIcon as BaseIcon } from '@fortawesome/vue-fontawesome'

export default BaseIcon
</script>
